import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type MatchReportsPayload = {
	foundReportId: string;
	lossReportId: string;
};

const matchReports = async (payload: MatchReportsPayload): Promise<any> => {
	const response = await apiDal.post("/match/matchfindandlossreports", payload);
	return response.data;
};

export const useMatchReports = () => {
	return useMutation({
		mutationFn: matchReports,
	});
};
